module.exports = __webpack_public_path__ + "media/images/channels/gastroenterology-1c92922f88d401ff6817fed8a9b3d329.jpg";